import { onBeforeUnmount, onMounted } from "vue";

type Options = {
  enabled?: boolean;
  onPaste: (list: FileList) => void;
};

const DEFAULT_OPTIONS: Options = {
  enabled: true,
  onPaste: () => {},
};

const filesToFileList = (files: File[]): FileList => {
  const dataTransfer = new DataTransfer();
  for (const file of files) {
    dataTransfer.items.add(file);
  }
  return dataTransfer.files;
};

export function usePasteImage(options: Options) {
  const currentOptions = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  const handlePaste = (event: ClipboardEvent) => {
    // The options should allow paste image
    if (!currentOptions.enabled) {
      return;
    }

    const fileArray: File[] = [];

    // Let's get all pasted items
    const items = event.clipboardData?.items;
    if (!items) {
      return;
    }

    for (const item of items) {
      // It should be an image
      if (item.type.startsWith("image/")) {
        // It should be a file
        const file = item.getAsFile();
        if (file) {
          // Let's try to use that file
          fileArray.push(file);
        }
      }
    }

    if (fileArray.length) {
      currentOptions.onPaste(filesToFileList(fileArray));
    }
  };

  onMounted(() => {
    if (currentOptions.enabled) {
      window.addEventListener("paste", handlePaste);
    }
  });

  onBeforeUnmount(() => {
    if (currentOptions.enabled) {
      window.removeEventListener("paste", handlePaste);
    }
  });

  return {};
}
